'use strict';

import 'angular';

import formModule from '../form';
import fieldDirective from './directive';

const MODULE_NAME = 'brg.rest.field';

var app = angular.module(MODULE_NAME, [
	'ngMessages',
	formModule
]);
app.directive('brgRestField', fieldDirective);

export default MODULE_NAME;
